import React, { useEffect } from 'react';
import { buildLogoutUrl } from '../utils/oidc';
import api from '../utils/api';

export default function Logout() {
  useEffect(() => {
    (async () => {
      try {
        await api.get('/auth/csrf');
        await api.post('/auth/logout');
      } catch {}
      try { window.localStorage.removeItem('currentUser'); } catch {}
      try {
        window.sessionStorage.removeItem('pkce_verifier');
        window.sessionStorage.removeItem('auth_callback_handled');
        window.sessionStorage.removeItem('pv_bearer_token');
        window.sessionStorage.setItem('force_reauth', '1');
        delete api.defaults.headers.common['Authorization'];
      } catch {}
      const domain = (typeof window !== 'undefined' && window.__COGNITO_DOMAIN__) || process.env.REACT_APP_COGNITO_DOMAIN || '';
      const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID || '';
      const logoutRedirectUri = window.location.origin + '/';
      if (domain && clientId) {
        const url = buildLogoutUrl({ domain, clientId, logoutRedirectUri });
        window.location.assign(url);
      } else {
        window.location.assign(logoutRedirectUri);
      }
    })();
  }, []);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      Signing you out…
    </div>
  );
}
